var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheckPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4375 34L29.8125 43.375L48.5625 24.625M65.75 34C65.75 51.2589 51.7589 65.25 34.5 65.25C17.2411 65.25 3.25 51.2589 3.25 34C3.25 16.7411 17.2411 2.75 34.5 2.75C51.7589 2.75 65.75 16.7411 65.75 34Z",
    stroke: "#6E56CF",
    strokeWidth: 4.98438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckPurple);
export default __webpack_public_path__ + "static/media/circle-check-purple.c75a17dc84ebfa3ab121c4786e98f0aa.svg";
export { ForwardRef as ReactComponent };